module.exports = __webpack_public_path__ + "static/media/robot.4f0f8dcf.jpg";